/**
 * Convert server pendingTerfaShadowSniperFlyAnimations to viewer-relative fly grant payloads.
 */

const TERFA_SHADOW_SNIPER_FLY_SOURCE = 'terfa_382';

function buildTerfaShadowSniperFlyOrderSnapshot(anim) {
  if (anim.grantedOrderInstanceId == null) {
    throw new Error('buildTerfaShadowSniperFlyOrderSnapshot: grantedOrderInstanceId is required');
  }
  if (anim.grantedOrderId == null) {
    throw new Error('buildTerfaShadowSniperFlyOrderSnapshot: grantedOrderId is required');
  }
  return {
    id: anim.grantedOrderId,
    name: anim.grantedOrderName || `Order ${anim.grantedOrderId}`,
    instanceId: anim.grantedOrderInstanceId,
    type: 'unit',
    isPlayable: true,
    isOOR: false,
  };
}

function consumePendingTerfaShadowSniperFlyAnimations(gameStateFragment, viewerUserId) {
  if (!gameStateFragment?.pendingTerfaShadowSniperFlyAnimations?.length) {
    return [];
  }
  if (viewerUserId == null) {
    throw new Error('consumePendingTerfaShadowSniperFlyAnimations: viewerUserId is required');
  }

  const pending = [...gameStateFragment.pendingTerfaShadowSniperFlyAnimations];
  delete gameStateFragment.pendingTerfaShadowSniperFlyAnimations;

  return pending
    .filter((anim) => String(anim.receivingPlayerId) === String(viewerUserId))
    .map((anim) => {
      if (!anim.animationKey) {
        throw new Error('consumePendingTerfaShadowSniperFlyAnimations: animationKey is required');
      }
      if (anim.providerZone == null || anim.providerSlotIndex == null) {
        throw new Error(
          `consumePendingTerfaShadowSniperFlyAnimations: provider slot required for ${anim.animationKey}`
        );
      }
      const zonePrefix =
        String(anim.providerPlayerId) === String(viewerUserId) ? 'your' : 'opponent';
      return {
        key: anim.animationKey,
        zone: `${zonePrefix}_${anim.providerZone}`,
        index: anim.providerSlotIndex,
        orderId: anim.grantedOrderId,
        orderName: anim.grantedOrderName,
        orderInstanceId: anim.grantedOrderInstanceId,
        sequenceIndex: anim.sequenceIndex ?? 0,
        source: anim.source || TERFA_SHADOW_SNIPER_FLY_SOURCE,
        orderSnapshot: buildTerfaShadowSniperFlyOrderSnapshot(anim),
      };
    });
}

module.exports = {
  TERFA_SHADOW_SNIPER_FLY_SOURCE,
  consumePendingTerfaShadowSniperFlyAnimations,
};
